import { useEffect, useState } from "react";
import { Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import MoldModal from "../components/MoldModal";
import { deleteMold, listMoldsPaged } from "../api/molds";
import { EmptyState, PageHeader, StatusBadge } from "../components/ui";

function Molds() {
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);

  function load() {
    listMoldsPaged({ page: page + 1, limit: rowsPerPage })
      .then((data) => {
        setList(data?.items || []);
        setTotal(Number(data?.total || 0));
      })
      .catch((err) => {
        console.error("MOLDS LOAD ERROR", err);
        alert("Kalıplar yüklenemedi");
        setList([]);
        setTotal(0);
      });
  }

  useEffect(() => { load(); }, [page, rowsPerPage]);

  function remove(id) {
    if (!window.confirm("Kalibi silmek istiyor musun?")) return;
    deleteMold(id).then(load).catch((err) => {
      console.error("MOLD DELETE ERROR", err);
      alert(err?.response?.data?.error?.message || "Kalıp silinemedi");
    });
  }

  function openNew() {
    setSelected(null);
    setModalOpen(true);
  }

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Kalıplar"
        subtitle="Kalıp tanımlarını ve seri numaralarını yönetin."
        actions={<Button variant="contained" onClick={openNew}>+ Yeni Kalıp</Button>}
      />
      {!list.length ? (
        <EmptyState description="Henüz kalıp tanımı yok." actionLabel="+ Yeni Kalıp" onAction={openNew} />
      ) : (
        <Paper>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Kalıp Adı</TableCell>
                <TableCell>Seri No</TableCell>
                <TableCell>Durum</TableCell>
                <TableCell align="right">İşlemler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((mold) => (
                <TableRow key={mold.id} hover>
                  <TableCell><Typography fontWeight={800}>{mold.name}</Typography></TableCell>
                  <TableCell>{mold.serial_no}</TableCell>
                  <TableCell><StatusBadge value={mold.status || "—"} /></TableCell>
                  <TableCell align="right">
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                      <Button size="small" variant="outlined" onClick={() => { setSelected(mold); setModalOpen(true); }}>Düzenle</Button>
                      <Button size="small" color="error" variant="outlined" onClick={() => remove(mold.id)}>Sil</Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div" count={total} page={page} rowsPerPage={rowsPerPage}
            onPageChange={(_, nextPage) => setPage(nextPage)}
            onRowsPerPageChange={(e) => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            rowsPerPageOptions={[10, 25, 50, 100]} labelRowsPerPage="Sayfa başına kayıt"
          />
        </Paper>
      )}
      {modalOpen ? <MoldModal data={selected} onClose={() => setModalOpen(false)} onSaved={load} /> : null}
    </Stack>
  );
}

export default Molds;
